import { useState, useEffect, startTransition } from 'react';

// Helper hook for mobile detection
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 1024 : false);

    useEffect(() => {
        const checkMobile = () => {
            startTransition(() => {
                setIsMobile(window.innerWidth < 1024);
            });
        };
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    return isMobile;
};
